const ShoppingIcon = ({className, pathClassName}) => (
  <svg
   className={className}
     viewBox="0 0 554 578"> 
  <path className={pathClassName} d="m396.4 193.6-31.7-6.4-4.5 306.9 55-12.9-18.8-287.6Zm-74.5-73.8c-9.6-19.1-22.3-29.7-35.8-29.7-3 0-6.2-.5-9.2 1.7l-2.2-.8c-6.2-5.5-13-8.3-20-8.3-14.1 0-27.2 11.4-37 32.1a180.7 180.7 0 0 0-14.7 73.3l-44.2-.8-31 278.1 223.7 25.3 4.5-307-18.5-.2A172.3 172.3 0 0 0 322 116v3.8Zm-41.3-25.5c1.8-.6 3.7-.8 5.5-.8 22.8 0 41.9 39.3 44.2 90l-24-.3a179 179 0 0 0-15-71.8 82 82 0 0 0-11.1-17.9h-.4l.8.8Zm-7.7 2.4c14.5 15.6 24.7 48.5 25.3 86.6l-57.1 1c1.5-39.5 13.7-74.2 30.6-86.8l1.2-.8Zm-19-9.9a23 23 0 0 1 13.7 5l-.6-.4c-18.7 14.6-31.6 50.6-33.2 92.1l-24.4-.4c-.5-54.3 20.3-98 44.4-98v1.8Z"/>
</svg>
)

export default ShoppingIcon
